import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08287a7e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=08287a7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08287a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08287a7e')) {
      api.createRecord('08287a7e', component.options)
    } else {
      api.reload('08287a7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08287a7e&scoped=true&", function () {
      api.rerender('08287a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/getbackList/index.vue"
export default component.exports